<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md10>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark>
                <v-toolbar-title>Terms And Conditions</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-layout justify-center>
                  <v-flex xs12 sm11 md11>
                    <span v-html="terms"></span>
                    <v-card-actions>
                      <v-btn color="primary"  @click.prevent="rollBack">Previous</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="success"  @click.prevent="proceed">Accept</v-btn>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>  
</template>
<script>
    export default {
        props: ['competitions','user'],
        computed: {
          terms(){
            if (this.user.data.competition_id) {
              let competition = this.competitions.find(competition => competition.id == this.user.data.competition_id);
              return competition.terms;
            }
            return '';
          }
        },
        methods: {
          rollBack(){
            this.$emit('rollback',this.user)
          },
          proceed (){
            this.$emit('completed',this.user);
          }
        }
   
    };
    
</script>
<style>
    
</style>


// WEBPACK FOOTER //
// src/components/Registeration/Terms.vue